<script>
  import { createEventDispatcher, onMount } from 'svelte';

  import DesktopGridSectionsBar from '@app-components/group/DesktopGridSectionsBar.svelte';
  import GridSection from '@app-components/group/GridSection.svelte';
  import NoRecsFoundText from '@app-components/group/NoRecsFoundText.svelte';
  import jQuery from 'jquery';
  import { sortBy } from 'lodash-es';

  const dispatch = createEventDispatcher();

  export let sections = [];
  export let group;
  export let currentUser;
  export let recs;
  let maxSectionsToShow = 6;

  function calculateSectionsToShow(screenSize) {
    if (screenSize <= 961) {
      maxSectionsToShow = 3;
    } else if (screenSize <= 1159) {
      maxSectionsToShow = 4;
    } else if (screenSize <= 1357) {
      maxSectionsToShow = 5;
    } else {
      maxSectionsToShow = 6;
    }
  }

  onMount(() => {
    let screenSize = jQuery(window).width();

    calculateSectionsToShow(screenSize);

    jQuery(window).on('resize.grid.section-bar', function () {
      screenSize = jQuery(window).width();
      calculateSectionsToShow(); // you have to call this function again to recalculate based on the new screenSize
    });

    return () => {
      jQuery(window).off('resize.grid.section-bar');
    };
  });
</script>

<style style="text/scss" lang="scss">
  /* global styles applied for "grid-content" in src/pages/group/Desktop.svelte */
</style>

{#if (sections && sections.length > 0) || group.permissions.edit || group.permissions.contribute}
  <DesktopGridSectionsBar
    maxShown={maxSectionsToShow}
    on:sticky-changed={(e) => {
      dispatch('sticky-changed', e.detail);
    }} />
{/if}

<div class="grid-content" id="group-sections">
  {#if sections && sections.length > 0}
    <div style="margin-top: 68px">
      {#each sortBy(sections, (x) => x.position) as section, i (section.id)}
        <GridSection id={section.id} lastSection={i === sections.length - 1} />
      {/each}
    </div>
  {:else if recs.length == 0}
    <NoRecsFoundText sectionsShown={maxSectionsToShow} mobile={false} currentUser={currentUser} group={group} />
  {:else}
    {#if !group.permissions.edit}
      <div style="margin-top: 50px" />
    {/if}
    <GridSection />
  {/if}
</div>
